import React, { useContext, useState, useEffect } from 'react';
import FittingRecommendationsListItem from './FittingRecommendationsListItem/FittingRecommendationsListItem';
import Styles from './FittingRecommendationsList.module.scss';
import { fittingRecommendationsContext } from '../../context/fittingRecommendationsContext';
import { LocalizationContext } from '../../context/localizationContext';

const FittingRecommendationsList = (props) => {
  const fittingRecommendationContext = useContext(
    fittingRecommendationsContext,
  );
  const { state } = fittingRecommendationContext;
  const { fittingRecommendations } = state;
  const { localizationState } = useContext(LocalizationContext);
  const { localization } = localizationState;
  const { webFitResults } = localization;

  return (
    <div
      className={`${Styles.recommendationsListContainer}
    `}
    >
      <div
        className={Styles.recommendationCount}
      >{`${webFitResults.recommendations} (${fittingRecommendations.length})`}</div>
      {fittingRecommendations
        && fittingRecommendations.map((recommendation, i) => {
          return (
            <div key={i} className={Styles.recommendationsListItemTile}>
              <FittingRecommendationsListItem recommendation={recommendation} />
            </div>
          );
        })}
    </div>
  );
};

export default FittingRecommendationsList;
